function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { join, split } from 'lodash';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { TiposDocStore } from 'src/_candidato/data/tiposStore';
import './panel-doc-notifications.scss';
var PanelDocNotificationsComponentCtrl = /*#__PURE__*/function () {
  PanelDocNotificationsComponentCtrl.$inject = ["$element", "$timeout", "$log", "NotifService", "AccesoDatos"];
  function PanelDocNotificationsComponentCtrl($element, $timeout, $log, NotifService, AccesoDatos) {
    _classCallCheck(this, PanelDocNotificationsComponentCtrl);
    _defineProperty(this, "$loading", false);
    _defineProperty(this, "$ready", false);
    this.$element = $element;
    this.$timeout = $timeout;
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelDocNotificationsComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[PanelDocNotificationsComponentCtrl] onInit');
      this._leerReglas();
    }
  }, {
    key: "_leerReglas",
    value: function _leerReglas() {
      var _this = this;
      this.$loading = true;
      this.AccesoDatos.Documentacion_CLIENT.reglasNotificacionDoc().then(function (reglasResponse) {
        _this.estados = reglasResponse.estados;
        _this.tiposDoc = new TiposDocStore(reglasResponse.tiposdocs);
        _this.reglas = reglasResponse.reglas.map(function (r) {
          return new ReglaNotifDoc(r, _this.estados, _this.tiposDoc);
        });
        _this.$loading = false;
        _this.$timeout(function () {
          return _this.$ready = true;
        }, 100);
      });
    }
  }, {
    key: "nuevaRegla",
    value: function nuevaRegla() {
      this.reglas.push(new ReglaNotifDoc({}, this.estados, this.tiposDoc));
    }
  }]);
}();
angular.module('candidato').component('panelDocNotifications', {
  bindings: {
    // empresa: "<",
  },
  controller: PanelDocNotificationsComponentCtrl,
  // templateUrl: "panel-doc-notifications.component.html",
  template: require('./panel-doc-notifications.component.html')
});
export var ReglaNotifDoc = /*#__PURE__*/function () {
  function ReglaNotifDoc(rule, estados, tiposDoc) {
    _classCallCheck(this, ReglaNotifDoc);
    _defineProperty(this, "mailsList", []);
    this.rule = rule;
    this.estados = estados;
    this.tiposDoc = tiposDoc;
  }
  return _createClass(ReglaNotifDoc, [{
    key: "actualiza",
    value: function actualiza(_rule) {
      this.rule = _rule;
    }
  }, {
    key: "estadosList",
    get: function get() {
      return this.estados.list;
    }
  }, {
    key: "tiposDocGruposList",
    get: function get() {
      return this.tiposDoc.gruposDocList();
    }
  }, {
    key: "mailsEnvioString",
    value: function mailsEnvioString() {
      var mails = split(this.rule.mail, /\;\\n/);
      return join(mails, '\n');
    }
  }, {
    key: "notifActiva",
    value: function notifActiva() {
      return this.rule.activanotif;
    }
  }]);
}();